var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99996 0.666664C2.91663 0.666664 1.13746 1.9625 0.416626 3.79166C1.13746 5.62083 2.91663 6.91666 4.99996 6.91666C7.08329 6.91666 8.86246 5.62083 9.58329 3.79166C8.86246 1.9625 7.08329 0.666664 4.99996 0.666664ZM4.99996 5.875C3.84996 5.875 2.91663 4.94166 2.91663 3.79166C2.91663 2.64166 3.84996 1.70833 4.99996 1.70833C6.14996 1.70833 7.08329 2.64166 7.08329 3.79166C7.08329 4.94166 6.14996 5.875 4.99996 5.875ZM3.74996 3.79166C3.74996 3.1 4.30829 2.54166 4.99996 2.54166C5.69163 2.54166 6.24996 3.1 6.24996 3.79166C6.24996 4.48333 5.69163 5.04166 4.99996 5.04166C4.30829 5.04166 3.74996 4.48333 3.74996 3.79166Z",
    fill: "#2186C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f27bc056075463603db70973eb4a0917.svg";
export { ForwardRef as ReactComponent };